// Volunteers.js
import React from 'react';

const Volunteers = () => {
  return (
    <div className="page volunteers-page">
      <h1>Volunteers</h1>
      <div className="volunteers-list">
        <p>Your volunteer history will appear here.</p>
      </div>
    </div>
  );
};

export default Volunteers;
